'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileFieldCell;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cancel = require('../icons/cancel');

var _cancel2 = _interopRequireDefault(_cancel);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function FileFieldCell(_ref) {
  var value = _ref.value;

  if (value) {
    return value;
  }

  return _react2.default.createElement('span', {
    className: 'rainbow-import-records-flow_step-three-cvs-field-not-assigned'
  }, 'Not assigned yet', _react2.default.createElement(_cancel2.default, {
    className: 'rainbow-import-records-flow_step-three-cancel-icon'
  }));
}

FileFieldCell.propTypes = {
  value: _propTypes2.default.string.isRequired
};